
import Vue from "vue";
import { optimizeImage } from "@/lib/utils/url";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    banner: Array,
  },
  methods: {
    ga(id) {
      (this as any).$ga.event("banner", "click", id, 1);
    },
    optimizedImage(url: string) {
      return optimizeImage(url);
    },
  },
});

interface Props {
  banner: object[];
}

interface Data {}

interface Computed {}

interface Methods {
  ga(id: string): void;
  optimizedImage(url: string): string;
}
